<template>
  <span aria-hidden="true"></span>
</template>

<script>
export default {
  name: 'ConsentManager',
  mounted() {
    if (!document.getElementById('anovator-consent-styles')) {
      const stylesheet = document.createElement('link')
      stylesheet.id = 'anovator-consent-styles'
      stylesheet.rel = 'stylesheet'
      stylesheet.href = '/static/css/consent.css'
      document.head.appendChild(stylesheet)
    }

    if (window.AnovatorConsent || document.getElementById('anovator-consent-bootstrap')) return

    const script = document.createElement('script')
    script.id = 'anovator-consent-bootstrap'
    script.src = '/static/js/consent-bootstrap.js'
    document.head.appendChild(script)
  }
}
</script>
